function initTippy(rootSelector) {
	tippy(rootSelector + ' *[title]', {
		content(reference) {
			const title = reference.getAttribute('title');
			reference.removeAttribute('title');
			return title;
		},
	});
}
document.addEventListener('DOMContentLoaded', function () {
	initTippy('body');

	naja.snippetHandler.addEventListener('afterUpdate', (event) => {
		initTippy('#' + event.detail.snippet.id);
	});
});